export const LOADING = 'LOADING';
